export const LOADING = 'LOADING';
